export default __webpack_public_path__ + "static/media/F0000.ea71f281.png";